// OccupiedTermsChart.js
import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import Chart from 'chart.js/auto';
import configApi from '../../config';

const OccupiedTermsChart = () => {
    const chartRef = useRef(null);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        const fetchRevenueData = async () => {
            try {
                const response = await axios.get(
                    `${configApi.apiEndpoint}/api/Stats/RevenueOverTime`,
                    config
                );
                const data = response.data;
                createChart(data);
            } catch (error) {
                console.error('Chyba pri načítavaní údajov o príjmoch:', error);
            }
        };

        const createChart = (data) => {
            const ctx = chartRef.current.getContext('2d');
            const gradient = ctx.createLinearGradient(0, 0, 0, 300);
            gradient.addColorStop(0, 'rgba(52, 152, 219, 0.5)'); // Ocean Blue
            gradient.addColorStop(1, 'rgba(52, 152, 219, 0.0)');

            const labels = data.map(item => `${item.year}-${item.month.toString().padStart(2, '0')}`);
            const revenues = data.map(item => item.revenue);

            if (chartRef.current) {
                const existingChart = Chart.getChart(chartRef.current);
                if (existingChart) {
                    existingChart.destroy();
                }
            }

            new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Mesačné príjmy (€)',
                        data: revenues,
                        fill: true,
                        backgroundColor: gradient,
                        borderColor: '#3498db',
                        borderWidth: 3,
                        tension: 0.4,
                        pointRadius: 4,
                        pointHoverRadius: 7,
                        pointBackgroundColor: '#3498db',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: 'Príjmy (€)'
                            },
                            ticks: {
                                callback: function (value) {
                                    return new Intl.NumberFormat('sk-SK').format(value) + ' €';
                                }
                            }
                        },
                        x: {
                            title: {
                                display: true,
                                text: 'Mesiac'
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        title: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    let label = context.dataset.label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += new Intl.NumberFormat('sk-SK').format(context.parsed.y) + ' €';
                                    }
                                    return label;
                                }
                            }
                        }
                    }
                }
            });
        };

        fetchRevenueData();
    }, []);

    return (
        <div className="card-custom h-100">
            <div className="card-custom-header">
                <h5>Mesačné príjmy</h5>
            </div>
            <div style={{ height: '300px' }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

export default OccupiedTermsChart;
